import { OpeningDay } from "../../types/property";

import styles from "./opening-days.module.css";

interface OpeningHoursProps {
  value: OpeningDay[];
  onChange: (hours: OpeningDay[]) => void;
}

export const days = [
  { dayOfWeek: 1, short: "M", label: "Montag" },
  { dayOfWeek: 2, short: "D", label: "Dienstag" },
  { dayOfWeek: 3, short: "M", label: "Mittwoch" },
  { dayOfWeek: 4, short: "D", label: "Donnerstag" },
  { dayOfWeek: 5, short: "F", label: "Freitag" },
  { dayOfWeek: 6, short: "S", label: "Samstag" },
  { dayOfWeek: 7, short: "S", label: "Sonntag" },
];

const getDefaultHours = (): OpeningDay[] =>
  days.map(({ dayOfWeek }) => ({
    dayOfWeek,
    isOpen: false,
    openTime: null,
    closeTime: null,
  }));

export const OpeningDays = ({ value, onChange }: OpeningHoursProps) => {
  const hours = getDefaultHours().map((defaultDay) => {
    const savedDay = value?.find(
      (day) => day.dayOfWeek === defaultDay.dayOfWeek
    );

    return savedDay ?? defaultDay;
  });

  const toggleDay = (dayOfWeek: number) => {
    onChange(
      hours.map((day) =>
        day.dayOfWeek === dayOfWeek
          ? {
              ...day,
              isOpen: !day.isOpen,
              openTime: day.isOpen ? null : "hh:mm",
              closeTime: day.isOpen ? null : "hh:mm",
            }
          : day
      )
    );
  };

  const updateTime = (
    dayOfWeek: number,
    field: "openTime" | "closeTime",
    time: string
  ) => {
    onChange(
      hours.map((day) =>
        day.dayOfWeek === dayOfWeek ? { ...day, [field]: time || null } : day
      )
    );
  };

  return (
    <div className={styles.container}>
      <label className={styles.heading}>Öffnungszeiten</label>

      <div className={styles.days}>
        {days.map((day) => {
          const selectedDay = hours.find(
            (item) => item.dayOfWeek === day.dayOfWeek
          )!;

          return (
            <button
              key={day.dayOfWeek}
              type="button"
              className={`${styles.dayCircle} ${
                selectedDay.isOpen ? styles.selected : ""
              }`}
              onClick={() => toggleDay(day.dayOfWeek)}
              aria-label={day.label}
              aria-pressed={selectedDay.isOpen}
              title={day.label}
            >
              {day.short}
            </button>
          );
        })}
      </div>

      <div className={styles.timeRows}>
        {hours
          .filter((day) => day.isOpen)
          .map((day) => {
            const dayInfo = days.find(
              (item) => item.dayOfWeek === day.dayOfWeek
            )!;

            return (
              <div className={styles.timeRow} key={day.dayOfWeek}>
                <span className={styles.dayLabel}>{dayInfo.label}</span>

                <input
                  type="time"
                  value={day.openTime ?? ""}
                  onChange={(e) =>
                    updateTime(day.dayOfWeek, "openTime", e.target.value)
                  }
                  aria-label={`${dayInfo.label} Öffnungszeit`}
                  aria-placeholder="hh:mm"
                  required
                />

                <span>–</span>

                <input
                  type="time"
                  value={day.closeTime ?? ""}
                  min={day.openTime ?? undefined}
                  onChange={(e) =>
                    updateTime(day.dayOfWeek, "closeTime", e.target.value)
                  }
                  aria-label={`${dayInfo.label} Schließzeit`}
                  required
                />
              </div>
            );
          })}
      </div>
    </div>
  );
};
